import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex gap-8 pb-4 px-2 items-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-xs font-medium text-gray-700" }

import { ref, computed, watch } from "vue";
import SidebarNavigation from "../../sidebar/sidebarNavigation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormTextList',
  props: {
    filter: { default: () => ({}) },
    activeValue: { default: () => [] }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toggleValue = (val: string) => {
  let newValue = Array.isArray(props.activeValue) ? [...props.activeValue] : [];
  const index = newValue.indexOf(val);
  if (index > -1) {
    newValue.splice(index, 1);
  } else {
    newValue.push(val);
  }
  emit("update", newValue);
};

const isActive = (val: string) => {
  return Array.isArray(props.activeValue) && props.activeValue.includes(val);
};

const itemKeys = computed(() => Object.keys(props.filter.values || {}));
const itemRefs = ref<HTMLElement[]>([]);
const scrollContainer = ref<HTMLElement | null>(null);
const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = itemRefs.value[index];
  if (el && scrollContainer.value) {
    const container = scrollContainer.value;
    const elLeft = el.offsetLeft;
    const elWidth = el.clientWidth;
    const containerWidth = container.clientWidth;
    const targetScrollLeft = elLeft - (containerWidth / 2) + (elWidth / 2);
    container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  }
};

watch(() => props.activeValue, () => {
  const keys = itemKeys.value;
  const active = Array.isArray(props.activeValue) ? props.activeValue[0] : props.activeValue;
  const idx = keys.indexOf(active?.toString() || '');
  if (idx >= 0) manualIndex.value = idx;
}, { immediate: true });

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  itemRefs.value.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "overflow-x-auto no-scrollbar scroll-smooth",
      onScroll: onScroll
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.values, (label, val, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: val,
            ref_for: true,
            ref: el => { if (el && index !== undefined) itemRefs.value[index] = el as any },
            class: "flex flex-col items-center cursor-pointer min-w-fit justify-end",
            onClick: ($event: any) => (toggleValue(val.toString()))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["px-4 py-2 flex items-center justify-center mb-2 transition-all duration-300 overflow-hidden", isActive(val.toString()) ? 'border-b border-brand-main' : ''])
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(val), 1)
            ], 2)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ], 544),
    _createVNode(SidebarNavigation, {
      total: itemKeys.value.length,
      modelValue: currentIndex.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentIndex).value = $event)),
      container: scrollContainer.value
    }, null, 8, ["total", "modelValue", "container"])
  ]))
}
}

})